module.exports = __webpack_public_path__ + "static/media/TMT-CORT010-120-tablet.aae284d4.jpg";